import { optionalCpf } from "@/lib/identity-validation";
import * as Yup from "yup";
import { useTranslation } from "react-i18next";
import { isValidPhoneNumber } from "react-phone-number-input";

export function CollaboratorValidationSchema() {
  const { t } = useTranslation();

  const validation = Yup.object().shape({
    name: Yup.string()
      .min(3, t("LABEL.min"))
      .max(50, t("LABEL.max"))
      .required(t("LABEL.required")),
    email: Yup.string()
      .email(t("LABEL.invalid email"))
      .min(3, t("LABEL.min"))
      .max(50, t("LABEL.max"))
      .required(t("LABEL.required")),
    cpf: optionalCpf(),
    phone: Yup.string()
      .required(t("LABEL.required"))
      .test("is-valid-phone", t("LABEL.invalid phone"), (value) => {
        if (!value) return true;
        return isValidPhoneNumber(value);
      }),
    crm: Yup.string().optional(),
    positionsId: Yup.string().required(t("LABEL.required")),
    address: Yup.string()
      .min(3, t("LABEL.min"))
      .max(50, t("LABEL.max"))
      .required(t("LABEL.required")),
    interval: Yup.string().optional(),
    profession: Yup.string().optional(),
    payment: Yup.string().required(t("LABEL.required")),
  });

  return validation;
}
